"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var faCheckCircle = require('@fortawesome/pro-solid-svg-icons/faCheckCircle');
var faHexagonExclamation = require('@fortawesome/pro-solid-svg-icons/faHexagonExclamation');
var faTriangleExclamation = require('@fortawesome/pro-solid-svg-icons/faTriangleExclamation');
var faCircleNotch = require('@fortawesome/pro-regular-svg-icons/faCircleNotch');
var s = require('react-hot-toast');
var a = require('styled-components');
var jsxRuntime = require('react/jsx-runtime');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var s__default = /*#__PURE__*/_interopDefaultLegacy(s);
var a__default = /*#__PURE__*/_interopDefaultLegacy(a);

var t=a__default["default"].div`
  font-size: var(--font-size-regular);
`,i=a__default["default"](chunkLXX3SSRV_js.b)`
  animation: spinner 0.6s linear infinite;

  @keyframes spinner {
    to {
      transform: rotate(360deg);
    }
  }
`;var m=(r,o={})=>s__default["default"](r,o),u=(r,o={})=>s__default["default"].success(r,o),f=(r,o={})=>s__default["default"].error(r,o),b=(r,o={})=>s__default["default"].loading(r,o),v=(r,o={})=>s__default["default"](r,{style:{background:"var(--background-warning)",border:"var(--border-width-x-small) solid var(--border-warning)"},icon:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{colorToken:"foreground-warning",icon:faTriangleExclamation.faTriangleExclamation,size:"regular"}),...o}),T=r=>s__default["default"].dismiss(r),k=()=>jsxRuntime.jsx(t,{children:jsxRuntime.jsx(s.Toaster,{position:"top-center",toastOptions:{duration:6e3,style:{background:"var(--background-app)",border:"var(--border-width-x-small) solid var(--border-input-hover)",borderRadius:"var(--border-radius-small)",color:"var(--foreground-primary)",justifyContent:"flex-start",padding:"var(--spacing-small) var(--spacing-regular)",boxShadow:"var(--elevation-300)"},success:{icon:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{colorToken:"foreground-success",icon:faCheckCircle.faCheckCircle,size:"regular"}),style:{background:"var(--background-success)",border:"var(--border-width-x-small) solid var(--border-success)"}},error:{icon:jsxRuntime.jsx(chunkLXX3SSRV_js.b,{colorToken:"foreground-error",icon:faHexagonExclamation.faHexagonExclamation,size:"regular"}),style:{background:"var(--background-error)",border:"var(--border-width-x-small) solid var(--border-error)"}},loading:{icon:jsxRuntime.jsx(i,{icon:faCircleNotch.faCircleNotch,size:"regular",colorToken:"color-neutral-400"})}}})}),x={show:m,success:u,danger:f,warning:v,loading:b,dismiss:T};

exports.a = k;
exports.b = x;
